import { useState, useEffect, useCallback } from "react";
import api from "../utils/api";
import toast from "react-hot-toast";

export function useMaintenance() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/maintenance");
      setRecords(data);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load maintenance records");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  async function addRecord(payload) {
    const { data } = await api.post("/api/maintenance", payload);
    setRecords(prev => [...prev, data]);
    return data;
  }

  async function updateRecord(id, payload) {
    const { data } = await api.put(`/api/maintenance/${id}`, payload);
    setRecords(prev => prev.map(r => (r.id === id ? data : r)));
    return data;
  }

  async function completeRecord(id) {
    const { data } = await api.post(`/api/maintenance/${id}/complete`);
    setRecords(prev => prev.map(r => (r.id === id ? data : r)));
    return data;
  }

  async function removeRecord(id) {
    await api.delete(`/api/maintenance/${id}`);
    setRecords(prev => prev.filter(r => r.id !== id));
  }

  return { records, loading, addRecord, updateRecord, completeRecord, removeRecord, reload: load };
}
